import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { CreatePalletTemplate } from 'themes/modules/order/pages';

class CreatePallet extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <CreatePalletTemplate {...this.props} />;
	}
}

export default defaultTemplate(CreatePallet);
